import React, { useState, useEffect } from "react";
import { Mail, Lock, Eye, EyeOff, LogIn } from "lucide-react";
import { useNavigate, Link } from "react-router-dom";
import logo from "../assets/logo-pm.svg";
import request from "../utils/request";
import getLandingPage from "../utils/authRedirect";

const LoginPage = () => {
  useEffect(() => {
    document.title =
      " تسجيل الدخول - الإدارة العامة للعمليات والتوقيع الإلكتروني";
  }, []);
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // const handleLogin = async (e) => {
  //   e.preventDefault();

  //   if (!email || !password) {
  //     alert("يرجى إدخال البريد الإلكتروني وكلمة المرور");
  //     return;
  //   }

  //   setLoading(true);

  //   try {
  //     const data = await request("/api/auth/login", {
  //       method: "POST",
  //       body: JSON.stringify({ email, password }),
  //     });
  //     console.log("الرد من السيرفر:", data);

  //     const token = data.token || (data.data && data.data.token);

  //     const actualToken = token || (data.data && data.data.token);

  //     if (actualToken) {
  //       localStorage.setItem("token", actualToken); // حفظ التوكن كنص فقط
  //       console.log("تم حفظ التوكن بنجاح كـ نص:", actualToken);
  //     } else {
  //       console.error("لم يتم العثور على توكن في رد السيرفر");
  //     }

  //     localStorage.setItem("user", JSON.stringify(data.user || data.data?.user));

  //     if (data.message === "OTP required") {
  //       localStorage.setItem("tempEmail", email);
  //       navigate("/verify-otp");
  //       return;
  //     }

  //     // ✅ التعديل هنا: تأكد من أن data.token هي القيمة الصحيحة

  //     if (data.user && Number(data.user.roleId) === 2) {
  //       navigate("/support");
  //     } else {
  //       navigate("/dashboard");
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     alert(error.message || "فشل تسجيل الدخول");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      alert("يرجى إدخال البريد الإلكتروني وكلمة المرور");
      return;
    }

    setLoading(true);

    try {
      const data = await request("/api/auth/login", {
        method: "POST",
        body: JSON.stringify({ email, password }),
      });

      console.log("الرد من السيرفر:", data);

      // 1. التعامل مع حالة الـ OTP أولاً (حسب منطقك)
      if (data.message === "OTP required") {
        localStorage.setItem("tempEmail", email);
        navigate("/verify-otp");
        return;
      }

      // 2. استخراج التوكن والمستخدم بشكل آمن (يدعم data.token أو data.data.token)
      const token = data.token || (data.data && data.data.token);
      const user = data.user || (data.data && data.data.user) || null;

      if (token) {
        localStorage.setItem("token", token);
        console.log("تم حفظ التوكن بنجاح:", token);
      } else {
        console.error(
          "فشل استخراج التوكن! الرد لا يحتوي على حقل token في المسارات المتوقعة",
        );
      }

      if (user) {
        localStorage.setItem("user", JSON.stringify(user));
      }

      // التوجيه: allowedPage أولاً لو موجودة، غير كده حسب الدور الوظيفي
      navigate(getLandingPage(user));
    } catch (error) {
      console.error(error);
      alert(error.message || "فشل تسجيل الدخول");
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="flex min-h-screen font-ibm bg-white" dir="rtl">
      <div className="flex flex-col justify-center items-center w-full lg:w-1/2 p-8 relative">
        <div className="max-w-md w-full">
          <div className="flex flex-col items-center mb-10">
            <Link to="/" className="block">
              <img src={logo} alt="Logo" style={{ width: "70%" }} />
            </Link>
          </div>

          <div className="text-right mb-8">
            <h2 className="text-3xl font-bold text-[#263238] mb-2">
              تسجيل الدخول
            </h2>
            <p className="text-gray-500 text-sm">
              يمكنك الدخول على حسابك باستخدام البريد الإلكتروني وكلمة المرور
            </p>
          </div>

          <form className="space-y-5" onSubmit={handleLogin}>
            {/* حقل البريد الإلكتروني */}
            <div className="relative group">
              <input
                type="email"
                id="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder=" "
                className="block w-full p-4 pr-12 text-right bg-gray-50 border border-gray-100 rounded-xl focus:ring-2 focus:ring-[#263238] outline-none transition-all peer"
              />
              <label
                htmlFor="email"
                className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[right] right-12 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 peer-focus:text-[#263238] pointer-events-none"
              >
                البريد الإلكتروني
              </label>
              <Mail
                className="absolute top-1/2 right-4 -translate-y-1/2 text-gray-400"
                size={20}
              />
            </div>

            {/* حقل كلمة المرور */}
            <div className="relative group">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder=" "
                className="block w-full p-4 pr-12 pl-12 text-right bg-gray-50 border border-gray-100 rounded-xl focus:ring-2 focus:ring-[#263238] outline-none transition-all peer"
              />
              <label
                htmlFor="password"
                className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[right] right-12 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 peer-focus:text-[#263238] pointer-events-none"
              >
                كلمة المرور
              </label>
              <Lock
                className="absolute top-1/2 right-4 -translate-y-1/2 text-gray-400"
                size={20}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute top-1/2 left-4 -translate-y-1/2 text-gray-400 hover:text-[#263238] transition-colors z-20"
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>

            <div className="flex items-center justify-between px-1">
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  id="remember"
                  className="w-4 h-4 rounded border-gray-300 text-[#263238] focus:ring-[#263238]"
                />
                <label
                  htmlFor="remember"
                  className="text-xs text-gray-500 font-medium cursor-pointer"
                >
                  تذكرني
                </label>
              </div>
              <Link
                to="/forgot-password"
                size="10"
                className="text-xs text-[#263238] font-medium hover:underline"
              >
                نسيت كلمة المرور؟
              </Link>
            </div>

            {/* زر الدخول مع حالة التحميل */}
            <button
              onClick={handleLogin}
              type="submit"
              disabled={loading}
              className={`w-full ${loading ? "bg-gray-400" : "bg-[#546E7A] hover:bg-[#263238]"} text-white font-bold py-3.5 rounded-xl shadow-lg transition-all flex items-center justify-center gap-2 mt-4 active:scale-[0.98]`}
            >
              <LogIn size={20} className="rotate-180" />
              <span>{loading ? "جاري التحقق..." : "تسجيل الدخول"}</span>
            </button>
          </form>
        </div>

        <div className="absolute bottom-6 text-[12px] text-gray-400 text-center w-full">
          © 2026 جميع الحقوق محفوظة للإدارة العامة للعمليات والتوقيع الإلكتروني
        </div>
      </div>

      <div className="hidden lg:flex flex-col justify-center items-center w-1/2 bg-gradient-to-br from-[#607D8B] to-[#263238] p-12 text-white relative overflow-hidden">
        <div className="absolute top-[-10%] left-[-10%] w-64 h-64 bg-white opacity-5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-96 h-96 bg-black opacity-10 rounded-full blur-3xl"></div>
        <div className="relative z-10 text-center max-w-md">
          <h2 className="text-4xl font-extrabold mb-6 leading-tight">
            أهلاً بك في نظام الإدارة العامة للعمليات والتوقيع الإلكتروني
          </h2>
          <p className="text-lg opacity-80 font-light leading-relaxed">
            مكان واحد يجمع فريقك، خططك، ونجاحاتك. صُمم خصيصاً ليناسب تطلعاتك
            الكبيرة.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;